import BatteryPackProducerScore from './batteryPackProducerScore';

export default BatteryPackProducerScore;
